import { useState } from "react";
import TextField from '@mui/material/TextField';
import Alert from '../components/Alert/Alert.jsx';

import style from "../components/LoginForm/LoginForm.module.css";
import { useTranslation } from 'react-i18next';
import { forgotPassword } from "../api/auth";

const ForgotPassword = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [alert, setAlert] = useState({ show: false, text: "", type: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await forgotPassword(email);
      setAlert({ show: true, text: t('forgot_password.success'), type: "success" });
    } catch (err) {
      setAlert({ show: true, text: err.message, type: "error" });
    }
  };

  return (
    <>
      {alert.show && (
        <Alert
          text={alert.text}
          type={alert.type}
          onClose={() => setAlert({ show: false, text: "", type: "" })}
        />
      )}    
      <div className={`${style.forgotPassword} ${style.formContainer}`}>
        <h2 className={style.formHeader}>{t('forgot_password.title')}</h2>
        <form 
          onSubmit={handleSubmit} 
          className={`${style.form} ${style.forgotPassForm}`}
      >
        <TextField 
          type="email" 
          name="email" 
          value={email} 
          onChange={(e) => setEmail(e.target.value)}
          required 
          id="outlined-required"
          label="Email"
          placeholder={t('forgot_password.email_placeholder')}
          fullWidth
          margin="normal"
          slotProps={{
              inputLabel: {
                shrink: true,
              },
          }}
        />
        <div className={style.buttonsContainer}> 
          <button type="submit" className={`button ${style.loginButton} ${style.forgotPassButton}`}>
              {t('forgot_password.submit')}
          </button>
        </div>
      </form>
      </div>
    </>
  );
};

export default ForgotPassword;